import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import ActionsTableCell from 'components/common/table/ActionsTableCell';
import IconButton from 'components/common/buttons/IconButton';
import { get } from '@totalsoft/change-tracking-react';
import PropertySelector from 'features/common/components/property-selector/PropertySelector';

const LeasingIncomeSchemaPropertyComponent = ({ lens, properties, onDelete, validation, disabled }) => {
  return (
    <TableRow>
      <PropertySelector
        required
        lens={lens}
        properties={properties}
        validation={validation}
        disabled={disabled}
        valueField='value'
        container={TableCell}
      />
      <ActionsTableCell width='100px'>
        <IconButton type='delete' color='error' onClick={() => onDelete(lens.key |> get)} disabled={disabled} />
      </ActionsTableCell>
    </TableRow>
  );
};

LeasingIncomeSchemaPropertyComponent.propTypes = {
  lens: PropTypes.object,
  properties: PropTypes.array,
  onDelete: PropTypes.func,
  validation: PropTypes.object,
  disabled: PropTypes.bool
};

export default LeasingIncomeSchemaPropertyComponent;
